import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e037211"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-iq" }
const _hoisted_2 = { class: "nge-iq-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Super Quests", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-iq-sub" }, "MEC. A player holds one at a time, beside their other claims, for up to 2 months.", -1 /* HOISTED */))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "nge-iq-err"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Add cells", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-iq-how" }, " One cell a line: a root ID, a root ID and its soma point, or a soma point alone (x, y, z as Pyr shows them; a point alone is looked up in the segmentation, so open MEC first). A note for players may follow a #. A cell already in the Cell Library becomes a Super Quest. ", -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-iq-row" }
const _hoisted_10 = { class: "nge-iq-sub" }
const _hoisted_11 = { id: "nge-iq-cats" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "nge-iq-sub" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "nge-iq-msg"
}
const _hoisted_16 = { class: "nge-iq-sub" }
const _hoisted_17 = { class: "nge-iq-how" }
const _hoisted_18 = {
  key: 2,
  class: "nge-iq-sub"
}
const _hoisted_19 = {
  key: 3,
  class: "nge-iq-table"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Cell"),
    /*#__PURE__*/_createElementVNode("th", null, "Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Soma"),
    /*#__PURE__*/_createElementVNode("th", null, "State"),
    /*#__PURE__*/_createElementVNode("th", null, "Held by"),
    /*#__PURE__*/_createElementVNode("th", null, "Active time"),
    /*#__PURE__*/_createElementVNode("th", null, "Players"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1 /* HOISTED */))
const _hoisted_21 = {
  key: 0,
  class: "nge-iq-note"
}
const _hoisted_22 = { class: "nge-iq-soma" }
const _hoisted_23 = { class: "nge-iq-soma-btns" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Active time per claim", -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-iq-how" }, " Counted while the claimed cell is on screen, Pyr is in front, and the player did real work on it in the last 5 minutes: placed or moved a mark, annotation or highlight, merged or split, or saved the view. Looking around alone does not count. Kept per claim (cell and player), across visits and devices. Every MEC claim counts, not only Super Quests. ", -1 /* HOISTED */))
const _hoisted_29 = { class: "nge-iq-row" }
const _hoisted_30 = { class: "nge-iq-sub" }
const _hoisted_31 = {
  key: 0,
  class: "nge-iq-sub"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 4,
  class: "nge-iq-sub"
}
const _hoisted_34 = {
  key: 5,
  class: "nge-iq-table"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Cell"),
    /*#__PURE__*/_createElementVNode("th", null, "Player"),
    /*#__PURE__*/_createElementVNode("th", null, "State"),
    /*#__PURE__*/_createElementVNode("th", null, "Active time"),
    /*#__PURE__*/_createElementVNode("th", null, "Days"),
    /*#__PURE__*/_createElementVNode("th", null, "Edits"),
    /*#__PURE__*/_createElementVNode("th", null, "Views saved"),
    /*#__PURE__*/_createElementVNode("th", null, "Last")
  ])
], -1 /* HOISTED */))
const _hoisted_36 = {
  key: 0,
  class: "nge-iq-tag"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "nge-iq-btn nge-iq-refresh",
        disabled: $setup.loading,
        onClick: $setup.load
      }, _toDisplayString($setup.loading ? 'Loading…' : 'Refresh'), 9 /* TEXT, PROPS */, _hoisted_5)
    ]),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _hoisted_7,
    _hoisted_8,
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.pasted) = $event)),
      class: "nge-iq-paste",
      rows: "6",
      spellcheck: "false",
      placeholder: "720575940612345678, 123456, 234567, 3456 # big basket cell\n720575940698765432\n98765, 87654, 2345",
      onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      onKeyup: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      onKeypress: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
      [_vModelText, $setup.pasted]
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, [
        _createTextVNode("Category "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.category) = $event)),
          class: "nge-iq-cat",
          list: "nge-iq-cats",
          maxlength: "60",
          onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
          onKeyup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
          onKeypress: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $setup.category]
        ]),
        _createElementVNode("datalist", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (c) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c,
              value: c
            }, null, 8 /* PROPS */, _hoisted_12))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("span", _hoisted_13, [
        _createTextVNode(_toDisplayString($setup.lines.length) + " line" + _toDisplayString($setup.lines.length === 1 ? '' : 's'), 1 /* TEXT */),
        ($setup.needsLookup)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(", points looked up when you add")
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("button", {
        class: "nge-iq-btn nge-iq-primary",
        disabled: $setup.adding || !$setup.lines.length,
        onClick: $setup.add
      }, _toDisplayString($setup.adding ? 'Adding…' : 'Add to the list'), 9 /* TEXT, PROPS */, _hoisted_14)
    ]),
    ($setup.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.message), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("h3", null, [
      _createTextVNode("The list "),
      _createElementVNode("span", _hoisted_16, _toDisplayString($setup.quests.filter(q => q.status === 'pending').length) + " open of " + _toDisplayString($setup.quests.filter(q => q.status !== 'skipped').length), 1 /* TEXT */)
    ]),
    _createElementVNode("p", _hoisted_17, " To set a soma: Go to cell, put the crosshairs inside the soma, then Soma here. The point is where a claim opens, and it keeps the claim on the cell through edits. " + _toDisplayString($setup.withSoma) + " of the cells have one. ", 1 /* TEXT */),
    (!$setup.quests.length && !$setup.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_18, "No Super Quests yet."))
      : (_openBlock(), _createElementBlock("table", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.quests, (q) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: q.id,
                class: _normalizeClass({ 'nge-iq-off': q.status === 'skipped' })
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(q.segment_id), 1 /* TEXT */),
                  (q.notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(q.notes), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(q.category || ''), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'nge-iq-ok': $setup.somaSaved[q.id] })
                  }, _toDisplayString(q.nucleus_coords || 'none yet'), 3 /* TEXT, CLASS */),
                  _createElementVNode("span", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "nge-iq-btn",
                      title: "Show this cell in the view (MEC must be open)",
                      onClick: $event => ($setup.goToCell(q))
                    }, "Go to cell", 8 /* PROPS */, _hoisted_24),
                    _createElementVNode("button", {
                      class: "nge-iq-btn",
                      disabled: $setup.somaBusy === q.id,
                      title: "Save the crosshairs as this cell's soma point",
                      onClick: $event => ($setup.somaHere(q))
                    }, _toDisplayString($setup.somaBusy === q.id ? 'Saving…' : 'Soma here'), 9 /* TEXT, PROPS */, _hoisted_25)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString($setup.STATUS[q.status] || q.status), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(q.holder || ''), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString($setup.hours(q.active_seconds)), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(q.players || ''), 1 /* TEXT */),
                _createElementVNode("td", null, [
                  (q.status === 'pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-iq-btn",
                        disabled: $setup.removing === q.id,
                        onClick: $event => ($setup.remove(q))
                      }, _toDisplayString($setup.removing === q.id ? 'Taking off…' : 'Take off'), 9 /* TEXT, PROPS */, _hoisted_26))
                    : _createCommentVNode("v-if", true)
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])),
    _hoisted_27,
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("label", _hoisted_30, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.onlyQuests) = $event)),
          type: "checkbox"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelCheckbox, $setup.onlyQuests]
        ]),
        _createTextVNode(" Super Quests only")
      ]),
      ($setup.finished)
        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Finished cells: " + _toDisplayString($setup.finished.n) + ", median " + _toDisplayString($setup.hours($setup.finished.median)) + ", mean " + _toDisplayString($setup.hours(Math.round($setup.finished.mean))), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        class: "nge-iq-btn",
        disabled: !$setup.shownTimes.length,
        onClick: $setup.downloadCsv
      }, "Download CSV", 8 /* PROPS */, _hoisted_32)
    ]),
    (!$setup.shownTimes.length && !$setup.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_33, "No time counted yet."))
      : (_openBlock(), _createElementBlock("table", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shownTimes, (t) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: t.task_id + t.player
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(t.segment_id), 1 /* TEXT */),
                  (t.kind === 'interneuron')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(t.category || 'Super Quest'), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(t.player), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(t.status === 'completed' && t.mine ? 'Finished' : t.mine ? ($setup.STATUS[t.status] || t.status) : 'Let go'), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString($setup.hours(t.active_seconds)), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(t.days), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(t.edits), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(t.views_saved), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(new Date(t.last_at).toLocaleDateString()), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
  ]))
}